import React from "react";
import "./App.css";
import NewsPaper from "./Components/NewsPaper/NewsPaper";

function App() {
	return (
		<div className="App">
			<NewsPaper />
		</div>
	);
}

export default App;
